"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.JoinCallButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _components = require("../../../components");
var _utils = require("../../../utils");
var _ForceFinishCallDialog = _interopRequireDefault(require("./ForceFinishCallDialog"));
var _WrongBrowserAlert = require("./WrongBrowserAlert");
var _excluded = ["className", "disabled", "onClick", "companionId", "skipWrongBrowserAlert"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var JoinCallButton = function JoinCallButton(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _lodash.noop : _ref$onClick,
    companionId = _ref.companionId,
    _ref$skipWrongBrowser = _ref.skipWrongBrowserAlert,
    skipWrongBrowserAlert = _ref$skipWrongBrowser === void 0 ? false : _ref$skipWrongBrowser,
    props = _objectWithoutProperties(_ref, _excluded);
  if ((0, _utils.videoCallsNotSupported)() && !skipWrongBrowserAlert) {
    return /*#__PURE__*/_react.default.createElement(_WrongBrowserAlert.WrongBrowserAlert, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !disabled && companionId && /*#__PURE__*/_react.default.createElement(_ForceFinishCallDialog.default, {
    companionId: companionId
  }), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, _extends({
    className: className,
    onClick: onClick,
    disabled: disabled
  }, props)));
};
exports.JoinCallButton = JoinCallButton;
var _default = JoinCallButton;
exports.default = _default;